import React, { useState } from "react";
import { Button, Grid, Label, Icon, Popup } from "semantic-ui-react";
import moment from "moment-with-locales-es6";
import MainButtonsContainer from "features/FolderManager/components/MainButtonsContainer";
import AddDocsTvSecModal from "../modals/AddDocsTvSecModal";
import HistoricNurseHelpModal from "../../../../components/Others/HistoricNurseHelpModal";
import { isJson } from "utils/json";
import { getWaitingTimeTvSecFolderHelp } from "utils/tvSec";

moment.locale("fr");

const styles = {
	mainContainer: {
		backgroundColor: "rgb(1, 84, 111)",
		color: "#fff",
		padding: 10,
		borderRadius: "4px",
		border: "1px solid rgb(1, 84, 111)",
		boxShadow: "0px 9px 20px -23px rgba(148,148,148,1)",
		minHeight: 80,
		marginBottom: 10,
		width: "100%",
		display: "flex",
		alignItems: "center",
	},
	blocInfoHeader: {
		mainContainer: {
			padding: 5,
			borderRadius: 4,
			display: "flex",
			alignItems: "center",
		},
		label: {
			fontSize: "0.7em",
		},
		totalPrice: {
			fontSize: "1em",
			fontWeight: 600,
		},
		button: {
			cursor: "pointer",
			color: "white",
			border: "1px white solid",
			borderRadius: 4,
			textAlign: "center",
			marginTop: 5,
			backgroundColor: "transparent",
			padding: 5,
		},
		noAction: {
			color: "white",
			border: "1px white solid",
			borderRadius: 4,
			textAlign: "center",
			marginTop: 5,
			backgroundColor: "transparent",
			padding: 5,
		},
	},
	comments: {
		list: {
			maxHeight: "100px",
			overflow: "auto",
			padding: "5px",
		},
		container: {
			margin: "3px 0",
			maxHeigth: "150px",
			border: "1px solid whitesmoke",
			backgroundColor: "white",
			display: "flex",
			justifyContent: "space-between",
			padding: "3px 6px",
			borderRadius: "8px",
		},
		time: {
			color: "#d1b8b8",
			fontSize: "0.8em",
		},
		comment: {
			color: "black",
			width: "65%",
			backgroundColor: "white",
			borderRadius: "4px",
			padding: "0 3px",
		},
		who: {
			color: "rgb(0, 145, 125)",
			borderRadius: "3px",
			padding: "0px 5px",
			fontSize: "0.8em",
			textAlign: "right",
		},
	},
};
const TelesecSection = ({
	data,
	mode,
	isMobile,
	getTvSecStatus,
	needHelp,
	toggleNeedHelp,
	needHelpLoading,
	cleanScans,
	tvSecScans,
	addScanOrdoToPrescription,
	removeScanOrdo,
	loadingScans,
	getScansForTVsecretariat,
	togglePreregisterWaitingFlag,
	preregisterWaitingFlag,
	refreshCenterScans,
}) => {
	const [tvSecMoreInfo, setTvSecMoreInfo] = useState(false);
	const [addDocsTvSecModalFolderHelp, setAddDocsTvSecModalFolderHelp] = useState(null);
	const [historicModalFolderHelp, setHistoricModalFolderHelp] = useState(null);

	const getOthers = (fromNurseHelp, fromDocs) => {
		let barcodesFromNurse = isJson(fromNurseHelp)
			? JSON.parse(fromNurseHelp).flatMap((f) =>
					(f.bc && f.bc.ordo && f.bc.ordo.length > 0 ? f.bc.ordo : [])
						.concat(f.bc && f.bc.fpa && f.bc.fpa.length > 0 ? f.bc.fpa : [])
						.concat(f.bc && f.bc.other && f.bc.other.length > 0 ? f.bc.other.map((o) => o.bc) : [])
			  )
			: fromNurseHelp;
		return fromDocs.map((fd) => fd.barcode).filter((fd) => fd && !barcodesFromNurse.includes(fd));
	};
	const getAchievedBy = (folderHelp) => {
		const users = [
			...new Set(
				folderHelp.historics
					.filter((h) => h.status_from === "SUPPORT" && h.status_to === "REASSIGNED")
					.map((h) => {
						return { first_name: h.user.first_name, last_name: h.user.last_name, myTelForTvSec: h.user.myTelForTvSec };
					})
			),
		];
		return users.map((u) => (
			<>
				<Label size="tiny" style={{ marginLeft: "10px", marginBottom: "3px" }}>
					<Icon name="user" />
					{u?.first_name} {u?.last_name}
					{u?.myTelForTvSec ? (
						<Popup
							trigger={
								<Label
									circular
									color="blue"
									size="mini"
									onClick={() => window.open(`tel:${u?.myTelForTvSec}`)}
									style={{ cursor: "pointer", marginLeft: "3px" }}
								>
									<Icon name="call" style={{ marginRight: 0 }} />
								</Label>
							}
							content={`Appeler le ${u?.myTelForTvSec}`}
						/>
					) : (
						""
					)}
				</Label>{" "}
			</>
		));
	};

	return (
		<MainButtonsContainer mode={mode} style={{ padding: "0 0 2em 0" }}>
			{data.folders[0].folderHelp && (
				<>
					<Grid.Row
						style={{
							...styles.mainContainer,
							minHeight: tvSecMoreInfo ? "84px" : "45px",
							backgroundColor: "rgb(1, 84, 111)",
							color: "white",
							fontSize: "0.9em",
						}}
						className={isMobile() ? "mainButtonsGreenContainerMobile" : ""}
					>
						<Grid.Column mobile={16} tablet={16} computer={16}>
							<Grid>
								<Grid.Row
									style={{ margin: isMobile() ? "1em" : 0, paddingTop: "1em", paddingBottom: "1em" }}
									onClick={() => setTvSecMoreInfo(!tvSecMoreInfo)}
								>
									<Grid.Column computer={16} mobile={16}>
										<div style={{ display: "flex", justifyContent: "space-between" }}>
											<div>
												<Icon name="bell" />
												Télésecrétariat
												<Label style={{ marginLeft: "10px", marginBottom: "3px" }}>{getTvSecStatus(data.folders[0].folderHelp)} </Label>
												<Label color="teal" style={{ marginLeft: "10px" }}>
													<Icon name="time" />
													<Label.Detail>{getWaitingTimeTvSecFolderHelp(data.folders[0].folderHelp)}</Label.Detail>
												</Label>
												{data.folders[0].folderHelp.status === "SUPPORT" && (
													<Button style={{ marginLeft: "10px", marginBottom: "3px" }} as="div" labelPosition="right">
														<Button
															color={needHelp ? "orange" : "yellow"}
															onClick={(e) => {
																if (e !== undefined) e.preventDefault();
																toggleNeedHelp();
																e.stopPropagation();
															}}
															disabled={needHelpLoading}
														>
															<Icon name="question circle" />
															{needHelp ? "Aide demandée" : "Demande d'aide aux secrétaires"}
														</Button>
														{needHelp && (
															<Label
																as="a"
																basic
																pointing="left"
																onClick={(e) => {
																	if (e !== undefined) e.preventDefault();
																	toggleNeedHelp();
																	e.stopPropagation();
																}}
																disabled={needHelpLoading}
															>
																Annuler cette demande
															</Label>
														)}
													</Button>
												)}
												{data.folders[0].folderHelp.fromPreregister && data.folders[0].folderHelp.status === "SUPPORT" && (
													<Button style={{ marginLeft: "10px", marginBottom: "3px" }} as="div" labelPosition="right">
														<Button
															color={preregisterWaitingFlag ? "orange" : "red"}
															onClick={(e) => {
																if (e !== undefined) e.preventDefault();
																togglePreregisterWaitingFlag(data.folders[0].id, true);
																e.stopPropagation();
															}}
															disabled={needHelpLoading}
														>
															<Icon name="pause circle outline" />
															{preregisterWaitingFlag ? "Pré-inscription en attente" : "Mettre cette pré-inscription en attente"}
														</Button>
														{preregisterWaitingFlag && (
															<Label
																as="a"
																basic
																pointing="left"
																onClick={(e) => {
																	if (e !== undefined) e.preventDefault();
																	togglePreregisterWaitingFlag(data.folders[0].id, false);
																	e.stopPropagation();
																}}
																disabled={needHelpLoading}
															>
																Annuler
															</Label>
														)}
													</Button>
												)}
											</div>
											{data.folders[0]?.folderHelp?.dataPatient && <Label color="orange">Données patient à vérifier par préleveur</Label>}

											<div>
												<Icon name={tvSecMoreInfo ? "chevron up" : "chevron down"} onClick={() => setTvSecMoreInfo(!tvSecMoreInfo)} />
											</div>
										</div>
									</Grid.Column>
								</Grid.Row>

								<Grid.Row style={{ paddingTop: 0, margin: isMobile() ? "0 2em" : 0 }}>
									{tvSecMoreInfo && (
										<Grid.Column>
											<Grid>
												<Grid.Row>
													<Grid.Column computer={8} mobile={16}>
														{data.folders[0].folderHelp.fromPreregister && (
															<>
																<div>Service de pré-inscriptions</div>
																<div>
																	Demande reçue le {moment(data.folders[0].folderHelp.created_at).format("DD MMMM")} à{" "}
																	{moment(data.folders[0].folderHelp.created_at).format("HH:mm")}
																</div>
																{data.folders[0].folderHelp.urgent && (
																	<div>
																		<Icon name="fast forward" />
																		File d'attente prioritaire
																	</div>
																)}
																{!data.folders[0].folderHelp.urgent && (
																	<div>
																		<Icon name="forward" />
																		File d'attente non prioritaire
																	</div>
																)}
																{data.folders[0].folderHelp.notified_to && (
																	<div>
																		<Icon name="bullhorn" /> Notification de l'état du dossier à {data.folders[0].folderHelp.notified_to.first_name}{" "}
																		{data.folders[0].folderHelp.notified_to.last_name}
																	</div>
																)}
															</>
														)}
														{!data.folders[0].folderHelp.fromPreregister && (
															<>
																<div>
																	Demandé par :{" "}
																	<Label size="tiny" style={{ marginLeft: "10px", marginBottom: "3px" }}>
																		<Icon name="user" />
																		{data.folders[0].folderHelp.created_by ? data.folders[0].folderHelp.created_by.first_name : ""}{" "}
																		{data.folders[0].folderHelp.created_by ? data.folders[0].folderHelp.created_by.last_name : ""}
																	</Label>{" "}
																	{data.folders[0].center ? (
																		<Label>
																			<Icon name="map marker alternate" />
																			{data.folders[0].center.name}{" "}
																			{data.folders[0].center.tel && (
																				<Popup
																					trigger={
																						<Label
																							circular
																							color="blue"
																							size="mini"
																							onClick={() => window.open(`tel:${data.folders[0].center.tel}`)}
																							style={{ cursor: "pointer" }}
																						>
																							<Icon name="call" style={{ marginRight: 0 }} />
																						</Label>
																					}
																					content={`Appeler le ${data.folders[0].center.tel}`}
																				/>
																			)}
																		</Label>
																	) : (
																		""
																	)}
																</div>
																<div>
																	Demande :{" "}
																	{data.folders[0].folderHelp.analyzes ? (
																		<Label size="tiny" style={{ marginLeft: "10px", marginBottom: "3px" }}>
																			Analyses
																		</Label>
																	) : (
																		""
																	)}{" "}
																	{data.folders[0].folderHelp.other ? (
																		<Label color="orange" style={{ marginLeft: "10px" }}>
																			Autres
																		</Label>
																	) : (
																		""
																	)}
																</div>
																<div>
																	Documents :{" "}
																	{!isJson(data.folders[0].folderHelp.barcodes) &&
																		data.folders[0].folderHelp.barcodes.split(",").map((c) => (
																			<Label
																				size="tiny"
																				key={`bc-${c}`}
																				color={
																					data.prescriptions
																						.flatMap((presc) => presc.scans)
																						.filter((d) => !d.isDefaultScan && d.barcode)
																						.flatMap((d) => d.barcode.split("-"))
																						.includes(c)
																						? "green"
																						: "red"
																				}
																			>
																				<Icon name="barcode" /> {c}
																			</Label>
																		))}
																	{isJson(data.folders[0].folderHelp.barcodes) &&
																		JSON.parse(data.folders[0].folderHelp.barcodes).map((p) => (
																			<Label key={`struct-${p.presc}`} style={{ margin: "3px" }}>
																				{" "}
																				Prescription {p.presc} :{" "}
																				{p.bc &&
																					p.bc.ordo &&
																					p.bc.ordo.length > 0 &&
																					p.bc.ordo.map((c) => (
																						<Label
																							size="tiny"
																							key={`bc-ordo-${c}`}
																							color={
																								data.prescriptions
																									.flatMap((presc) => presc.scans)
																									.filter((d) => !d.isDefaultScan && d.barcode)
																									.flatMap((d) => d.barcode.split("-"))
																									.includes(c)
																									? "green"
																									: "red"
																							}
																						>
																							Ordonnance : <Icon name="barcode" /> {c}
																						</Label>
																					))}
																				{p.bc &&
																					p.bc.fpa &&
																					p.bc.fpa.length > 0 &&
																					p.bc.fpa.map((c) => (
																						<Label
																							size="tiny"
																							key={`bc-fpa-${c}`}
																							color={
																								data.prescriptions
																									.flatMap((presc) => presc.scans)
																									.filter((d) => !d.isDefaultScan && d.barcode)
																									.flatMap((d) => d.barcode.split("-"))
																									.includes(c)
																									? "green"
																									: "red"
																							}
																						>
																							FPA : <Icon name="barcode" /> {c}
																						</Label>
																					))}
																				{p.bc &&
																					p.bc.other &&
																					p.bc.other.length > 0 &&
																					p.bc.other.map((c) => (
																						<Label
																							size="tiny"
																							key={`bc-other-${c.bc}`}
																							color={
																								data.prescriptions
																									.flatMap((presc) => presc.scans)
																									.filter((d) => !d.isDefaultScan && d.barcode)
																									.flatMap((d) => d.barcode.split("-"))
																									.includes(c.bc)
																									? "green"
																									: "red"
																							}
																						>
																							{c.title} : <Icon name="barcode" /> {c.bc}
																						</Label>
																					))}
																				{p.bc &&
																					Array.isArray(p.bc) &&
																					p.bc.map((c) => (
																						<Label
																							size="tiny"
																							key={`bc-${c}`}
																							color={
																								data.prescriptions
																									.flatMap((presc) => presc.scans)
																									.filter((d) => !d.isDefaultScan && d.barcode)
																									.flatMap((d) => d.barcode.split("-"))
																									.includes(c)
																									? "green"
																									: "red"
																							}
																						>
																							<Icon name="barcode" /> {c}
																						</Label>
																					))}
																			</Label>
																		))}
																	{getOthers(
																		data.folders[0].folderHelp.barcodes,
																		data.prescriptions.flatMap((presc) => presc.scans)
																	).length > 0 && (
																		<Label key={`struct-others`}>
																			{" "}
																			Doc(s) supplémentaires :{" "}
																			{getOthers(
																				data.folders[0].folderHelp.barcodes,
																				data.prescriptions.flatMap((presc) => presc.scans)
																			).map((c) => (
																				<Label
																					size="tiny"
																					key={`bc-${c}`}
																					color={
																						data.prescriptions
																							.flatMap((presc) => presc.scans)
																							.filter((d) => !d.isDefaultScan && d.barcode)
																							.flatMap((d) => d.barcode.split("-"))
																							.includes(c)
																							? "green"
																							: "red"
																					}
																				>
																					<Icon name="barcode" /> {c}
																				</Label>
																			))}
																		</Label>
																	)}
																	{data.folders[0].folderHelp.status === "SUPPORT" && (
																		<Button
																			onClick={(e) => {
																				if (e !== undefined) e.preventDefault();
																				setAddDocsTvSecModalFolderHelp(data.folders[0].folderHelp);
																			}}
																			style={{ ...styles.blocInfoHeader.button, marginLeft: "20px" }}
																			icon
																			labelPosition="left"
																		>
																			<Icon name="search" />
																			Rechercher des documents
																		</Button>
																	)}
																</div>
															</>
														)}
														{data.folders[0].folderHelp &&
															data.folders[0].folderHelp.historics?.some((h) => h.status_from === "SUPPORT" && h.status_to === "REASSIGNED") && (
																<div>Traité par : {getAchievedBy(data.folders[0].folderHelp)}</div>
															)}
													</Grid.Column>
													<Grid.Column
														mobile={16}
														tablet={8}
														computer={data.folders[0].folderHelp.comments.filter((c) => c.manual).length === 0 ? 4 : 8}
													>
														<div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
															{data.folders[0].folderHelp.comments.filter((c) => c.manual).length > 0 && "Commentaires :"}
															{data.folders[0].folderHelp.comments.filter((c) => c.manual).length === 0 && "Pas de commentaires"}
															{/*  <Button
																onClick={ (e) => {if (e !== undefined) e.preventDefault();
																	this.setState({
																		addCommentNurseHelp: this.postCommentFolderHelp,
																	});
																	this.openCommentNurseHelp();
																}}
																icon
																style={{...styles.blocInfoHeader.button, marginLeft:'10px'}}
																labelPosition='left'
																>
																	<Icon name='comments outline' /> Ajouter un commentaire
															</Button> */}
															<Button
																onClick={(e) => {
																	if (e !== undefined) e.preventDefault();
																	setHistoricModalFolderHelp(data.folders[0].folderHelp);
																}}
																icon
																style={{ ...styles.blocInfoHeader.button, marginLeft: "10px" }}
																labelPosition="left"
															>
																<Icon name="history" /> Voir l'historique
															</Button>
														</div>
														<div style={{ ...styles.comments.list }}>
															{data.folders[0].folderHelp.comments
																.filter((c) => c.manual)
																.slice()
																.sort((a, b) => moment(b.created_at).toDate() - moment(a.created_at).toDate())
																.map((c) => (
																	<div style={{ ...styles.comments.container }} key={`commenthf-${c.id}`}>
																		<div style={styles.comments.comment}>
																			{c.cancellation && c.cancelReason && (
																				<Label basic>
																					<span style={{ fontSize: "0.9em" }}>Annulation de la demande de télésecrétariat : </span>{" "}
																					{c.cancelReason.label}
																				</Label>
																			)}
																			{c.comment && <div> {c.comment}</div>}
																		</div>

																		<div>
																			{c.created_by && (
																				<span style={{ ...styles.comments.who }}>
																					{c.created_by.first_name} {c.created_by.last_name}
																				</span>
																			)}
																			<span style={{ ...styles.comments.time }}>
																				{moment(c.created_at).format(
																					`${process.env.REACT_APP_DATE_DISPLAY_FORMAT}, ${process.env.REACT_APP_TIME_DISPLAY_FORMAT}`
																				)}
																			</span>
																		</div>
																	</div>
																))}
														</div>
													</Grid.Column>
												</Grid.Row>
											</Grid>
										</Grid.Column>
									)}
								</Grid.Row>
							</Grid>
						</Grid.Column>
					</Grid.Row>
				</>
			)}
			<AddDocsTvSecModal
				folderHelp={addDocsTvSecModalFolderHelp}
				open={!!addDocsTvSecModalFolderHelp}
				close={() => {
					cleanScans();
					setAddDocsTvSecModalFolderHelp(null);
				}}
				folder={data.folders[0]}
				getScansForTVsecretariat={getScansForTVsecretariat}
				refreshCenterScans={refreshCenterScans}
				scans={tvSecScans}
				addScanOrdoToPrescription={addScanOrdoToPrescription}
				removeScanOrdoFromList={removeScanOrdo}
				prescriptions={data.prescriptions}
				docs={data.prescriptions.flatMap((p) => p.scans)}
				loadingScans={loadingScans}
			/>
			<HistoricNurseHelpModal
				folderHelp={historicModalFolderHelp}
				open={!!historicModalFolderHelp}
				closeHistoricFolderHelpModal={() => setHistoricModalFolderHelp(null)}
			/>
		</MainButtonsContainer>
	);
};
export default TelesecSection;
